import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const TeamTile = ({ team, sport, path, image, primaryColor, secondaryColor, className = '' }) => {
  return (
    <Link
      to={path}
      data-testid={`team-tile-${team.toLowerCase()}`}
      className={`group relative overflow-hidden border-2 border-black shadow-brutal hover-lift block ${className}`}
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
        style={{ 
          backgroundImage: `url(${image})`,
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 gradient-overlay" />
      
      {/* Color Accent Bar */}
      <div 
        className="absolute top-0 left-0 right-0 h-2"
        style={{ backgroundColor: primaryColor }}
      />

      {/* Content */}
      <div className="relative h-full min-h-[280px] sm:min-h-[320px] p-6 flex flex-col justify-end">
        {/* Sport Label */}
        <div 
          className="inline-flex items-center gap-2 px-3 py-1 text-xs font-bold uppercase tracking-widest mb-3 w-fit border-2 border-black"
          style={{ 
            backgroundColor: secondaryColor,
            color: 'white'
          }}
        >
          {sport}
        </div>
        
        {/* Team Name */}
        <h3 className="font-heading text-3xl sm:text-4xl text-white uppercase tracking-tight mb-2 group-hover:text-amber-400 transition-colors">
          {team}
        </h3>
        
        {/* Arrow */}
        <div className="flex items-center gap-2 text-white/80 group-hover:text-amber-400 transition-all">
          <span className="text-sm font-bold uppercase tracking-wide">View Coverage</span>
          <ArrowRight className="w-5 h-5 transform group-hover:translate-x-2 transition-transform" />
        </div>
      </div>

      {/* Hover Border Effect */}
      <div 
        className="absolute inset-0 border-4 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
        style={{ borderColor: primaryColor }}
      />
    </Link>
  );
};

export default TeamTile;
